import { Container } from 'unstated';
import { getPersistentStore, getPersistentStoreMutex } from '@lemonadefashion/storage';

const KEY = 'latest_guest_access_code';
function _getStore() { return getPersistentStore(); }
function _getMutex() { return getPersistentStoreMutex(); }

function getGuestAccessCodeFromStore() {
  try {
    const infoJson = _getStore().getItem(KEY);
    if (infoJson == null) return null;
    return JSON.parse(infoJson);
  } catch (error) {
    console.log(error);
    return null;
  }
}

function updateGuestAccessCodeInStore(guestAccessCode) {
  return new Promise((resolve, reject) => {
    const mutex = _getMutex();
    const store = _getStore();
    mutex.lock(KEY)
      .then(() => {
        store.setItem(KEY, JSON.stringify(guestAccessCode));
        return mutex.release(KEY).then(resolve).catch(reject);
      })
      .catch(reject);
  });
}

class GuestAccessCodeContainer extends Container {
  constructor() {
    super();
    this.state = {
      guestAccessCode: getGuestAccessCodeFromStore()
    };
    window.addEventListener('storage', e => {
      if (e.key !== KEY) return;
      this.setState({ guestAccessCode: getGuestAccessCodeFromStore() });
    });
  }

  get() { return this.state.guestAccessCode; }

  set(guestAccessCode) {
    return new Promise((resolve, reject) => {
      updateGuestAccessCodeInStore(guestAccessCode)
        .catch(console.log)
        .finally(() => this.setState({ guestAccessCode: guestAccessCode }, resolve));
    });
  }
}

export default GuestAccessCodeContainer;
